import React, { useEffect, useState } from "react";
// eslint-disable-next-line import/no-unresolved
import "react-datepicker/dist/react-datepicker.css";
import DatePickers from "./BirthDatePicker";
import { getMaxDate } from "../../utils/commonFunctions";
import useMobile from "../../hooks/useMobile";
import MobileDateField from "./MobileDateField";
import moment from "moment";

type SectionPropTypes = {
  name: string;
  error: any;
  setError: any;
  setFieldValue: any;
  value: any;
  errorMessage: string;
  touched: any;
  errors: any;
};

function DateInput({ name, error, setError, value, setFieldValue, errorMessage, touched, errors }: SectionPropTypes) {
  const [rawValue, setRawValue] = useState<any>("");
  const restrictDate = getMaxDate();
  const isMobile = useMobile();

  const isValidDate = (dateString: any) => {
    const date: any = new Date(dateString);
    const restricDateString: any = new Date(restrictDate);

    // eslint-disable-next-line no-restricted-globals
    return !isNaN(date) && date.getTime() < restricDateString.getTime();
  };

  useEffect(() => {
    if (isValidDate(rawValue)) {
      setRawValue(moment(new Date(value)).format("MM/DD/YYYY"));
      setError(false);
    } else {
      setRawValue(rawValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  if (isMobile) {
    return (
      <MobileDateField
        name={name}
        value={value}
        rawValue={rawValue}
        setFieldValue={setFieldValue}
        setRawValue={setRawValue}
        error={error}
        setError={setError}
        errorMessage={errorMessage}
        restrictDate={restrictDate}
        touched={touched}
        errors={errors}
      />
    );
  }

  return (
    <DatePickers
      name={name}
      value={value}
      rawValue={rawValue}
      setFieldValue={setFieldValue}
      setRawValue={setRawValue}
      error={error}
      setError={setError}
      errorMessage={errorMessage}
      restrictDate={restrictDate}
      touched={touched}
      errors={errors}
    />
  );
}
export default DateInput;
